<template>
  <div class="card">
    <nav-bar :back="true"></nav-bar>
    <div v-if="selectedPollExists">
      <div v-if="votesAreLoading">
        <div class="loader-container">
          <loader />
        </div>
      </div>
      <div v-else>
        <h2 class="poll-title">{{ selectedPoll.texts[lang] }}</h2>
        <question-list 
          class="poll-questions"
          v-if="selectedPoll && !votesAreLoading"
          :poll="selectedPoll"
          :questions="questionsOfSelectedPoll"
          :user="user"
          :userVotes="userVotes"
          @questionSelected="goToQuestion"
        ></question-list>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { isEmpty } from 'ramda';
import QuestionList from '@/views/questions/QuestionList';
import NavBar from '@/components/navigation/NavBar';
import Loader from '@/components/loader/Loader';

export default {
  name: 'poll-content',
  components: {
    QuestionList,
    NavBar,
    Loader
  },
  computed: {
    ...mapGetters(['selectedPoll', 'questionsOfSelectedPoll', 'votesAreLoading', 'userVotes']),
    ...mapGetters({ lang: 'getInputLanguage'}),
    ...mapState(['user']),
    selectedPollExists() {
      return !isEmpty(this.selectedPoll);
    }
  },
  methods: {
    ...mapActions(['selectPoll', 'fetchUserVotes']),

    goToQuestion(questionId) {
      this.$router.push({
        name: 'questionContent',
        params: {
          pollId: this.selectedPoll.pollId,
          questionId
        }
      });
    }
  },
  mounted() {
    const pollId = this.$route.params.pollId;
    this.fetchUserVotes(pollId);
    this.selectPoll(pollId);
  }
};
</script>

<style lang="scss" scoped>
.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.poll-title {
  margin-top: 20px;
}
</style>
